var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-lti",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: false,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.currentTitle !== ""
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-title",
                        },
                        [_vm._v(_vm._s(_vm.currentTitle))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.toolId !== ""
                    ? _c("iframe", {
                        staticClass: "cw-block-lti-content",
                        attrs: {
                          src: _vm.iframeUrl,
                          height: _vm.currentHeight,
                          width: "100%",
                          allowfullscreen: "",
                          sandbox:
                            "allow-downloads allow-forms allow-popups allow-pointer-lock allow-same-origin allow-scripts",
                        },
                      })
                    : _c(
                        "div",
                        {
                          staticClass: "cw-block-lti-content",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "cw-block-lti-icon-tool",
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$gettext("Kein LTI-Tool konfiguriert")
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]
                      ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    var _vm$currentTool
                    return [
                      _c(
                        "courseware-tabs",
                        [
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 0,
                                name: _vm.$gettext("Grunddaten"),
                                selected: true,
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("Titel")) +
                                        "\n                            "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentTitle,
                                          expression: "currentTitle",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.currentTitle,
                                      },
                                      on: {
                                        input: function input($event) {
                                          if ($event.target.composing) return
                                          _vm.currentTitle = $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$gettext(
                                            "Auswahl des externen Tools"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentToolId,
                                            expression: "currentToolId",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentToolId = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _vm._l(_vm.tools, function (tool) {
                                          return _c(
                                            "option",
                                            {
                                              key: tool.id,
                                              domProps: {
                                                value: tool.id,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(tool.name) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "0",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$gettext(
                                                  "Zugangsdaten selbst eingeben..."
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      2
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.allowCustomUrl,
                                          expression: "allowCustomUrl",
                                        },
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$gettext(
                                              "URL der Anwendung (optional)"
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                      _c("studip-tooltip-icon", {
                                        attrs: {
                                          text: _vm.$gettext(
                                            "Sie können direkt auf eine URL in der Anwendung verlinken."
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentLaunchUrl,
                                            expression: "currentLaunchUrl",
                                          },
                                        ],
                                        attrs: {
                                          type: "text",
                                          placeholder:
                                            (_vm$currentTool =
                                              _vm.currentTool) === null ||
                                            _vm$currentTool === void 0
                                              ? void 0
                                              : _vm$currentTool.launch_url,
                                        },
                                        domProps: {
                                          value: _vm.currentLaunchUrl,
                                        },
                                        on: {
                                          input: function input($event) {
                                            if ($event.target.composing) return
                                            _vm.currentLaunchUrl =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.customToolSelected,
                                          expression: "customToolSelected",
                                        },
                                      ],
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "studiprequired",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$gettext(
                                                  "URL der Anwendung"
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "asterisk",
                                              attrs: {
                                                title: _vm.$gettext(
                                                  "Dies ist ein Pflichtfeld"
                                                ),
                                                "aria-hidden": "true",
                                              },
                                            },
                                            [_vm._v("*")]
                                          ),
                                          _vm._v(" "),
                                          _c("studip-tooltip-icon", {
                                            attrs: {
                                              text: _vm.$gettext(
                                                "Die Betreiber dieses Tools müssen Ihnen eine URL und Zugangsdaten (Consumer-Key und Consumer-Secret) mitteilen."
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.currentLaunchUrl,
                                                expression: "currentLaunchUrl",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              required: "",
                                            },
                                            domProps: {
                                              value: _vm.currentLaunchUrl,
                                            },
                                            on: {
                                              input: function input($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.currentLaunchUrl =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "studiprequired",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$gettext(
                                                  "Consumer-Key des LTI-Tools"
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "asterisk",
                                              attrs: {
                                                title: _vm.$gettext(
                                                  "Dies ist ein Pflichtfeld"
                                                ),
                                                "aria-hidden": "true",
                                              },
                                            },
                                            [_vm._v("*")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.currentConsumerKey,
                                                expression:
                                                  "currentConsumerKey",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              required: "",
                                            },
                                            domProps: {
                                              value: _vm.currentConsumerKey,
                                            },
                                            on: {
                                              input: function input($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.currentConsumerKey =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "studiprequired",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$gettext(
                                                  "Consumer-Secret des LTI-Tools"
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "asterisk",
                                              attrs: {
                                                title: _vm.$gettext(
                                                  "Dies ist ein Pflichtfeld"
                                                ),
                                                "aria-hidden": "true",
                                              },
                                            },
                                            [_vm._v("*")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.currentConsumerSecret,
                                                expression:
                                                  "currentConsumerSecret",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              required: "",
                                            },
                                            domProps: {
                                              value: _vm.currentConsumerSecret,
                                            },
                                            on: {
                                              input: function input($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.currentConsumerSecret =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("label", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$gettext(
                                                "OAuth Signatur Methode des LTI-Tools"
                                              )
                                            ) +
                                            "\n                                "
                                        ),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.currentOauthSignatureMethod,
                                                expression:
                                                  "currentOauthSignatureMethod",
                                              },
                                            ],
                                            on: {
                                              change: function change($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.currentOauthSignatureMethod =
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "sha1",
                                                },
                                              },
                                              [_vm._v("HMAC-SHA1")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "sha256",
                                                },
                                              },
                                              [_vm._v("HMAC-SHA256")]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.currentSendLisPerson,
                                                expression:
                                                  "currentSendLisPerson",
                                              },
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.currentSendLisPerson
                                              )
                                                ? _vm._i(
                                                    _vm.currentSendLisPerson,
                                                    null
                                                  ) > -1
                                                : _vm.currentSendLisPerson,
                                            },
                                            on: {
                                              change: function change($event) {
                                                var $$a =
                                                    _vm.currentSendLisPerson,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.currentSendLisPerson =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.currentSendLisPerson =
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                  }
                                                } else {
                                                  _vm.currentSendLisPerson = $$c
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$gettext(
                                                  "Nutzerdaten an LTI-Tool senden"
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                          _c("studip-tooltip-icon", {
                                            attrs: {
                                              text: _vm.$gettext(
                                                "Nutzerdaten dürfen nur an das externe Tool gesendet werden, wenn es keine Datenschutzbedenken gibt. Mit Setzen des Hakens bestätigen Sie, dass die Übermittlung der Daten zulässig ist."
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 1,
                                name: _vm.$gettext("Zusätzliche Einstellungen"),
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("Höhe")) +
                                        "\n                            "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentHeight,
                                          expression: "currentHeight",
                                        },
                                      ],
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                      },
                                      domProps: {
                                        value: _vm.currentHeight,
                                      },
                                      on: {
                                        input: function input($event) {
                                          if ($event.target.composing) return
                                          _vm.currentHeight =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$gettext(
                                              "Zusätzliche LTI-Parameter"
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                      _c("studip-tooltip-icon", {
                                        attrs: {
                                          text: _vm.$gettext(
                                            "Ein Wert pro Zeile, Beispiel: Review:Chapter=1.2.56"
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentCustomParameters,
                                            expression:
                                              "currentCustomParameters",
                                          },
                                        ],
                                        domProps: {
                                          value: _vm.currentCustomParameters,
                                        },
                                        on: {
                                          input: function input($event) {
                                            if ($event.target.composing) return
                                            _vm.currentCustomParameters =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$gettext("Informationen zum LTI-Block"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }